import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: 'How long does it take to see results?',
      answer: 'Typically, it takes 3-6 months to see significant results from digital marketing campaigns, especially for SEO. However, paid advertising (PPC) can generate traffic and leads almost immediately. We provide monthly reports so you can track progress.'
    },
    {
      question: 'Do you guarantee ROI for my business?',
      answer: 'While we cannot guarantee specific ROI due to various market factors, we guarantee our commitment to data-driven strategies and continuous optimization to maximize your return on investment.'
    },
    {
      question: 'Can you work within my budget?',
      answer: 'Yes, we offer flexible packages designed to accommodate different business sizes and budgets. We can prioritize the most impactful strategies based on your available resources.'
    },
    {
      question: 'What makes you different from others?',
      answer: 'Our approach is highly data-driven and transparent. We do not use cookie-cutter strategies; instead, we tailor every campaign to your specific business goals and provide completely transparent reporting.'
    }
  ];

  return (
    <section className="faq">
      <div className="container faq-container">
        <div className="faq-content">
          <span className="section-tag">FAQ's</span>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
                key={index}
                onClick={() => setActiveIndex(index)}
              >
                <div className="faq-question">
                  <h4>{faq.question}</h4>
                  <span className="faq-icon">{activeIndex === index ? '-' : '+'}</span>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
